module.exports = __webpack_public_path__ + "img/stena01.7893520d.jpg";